module.exports = __webpack_public_path__ + "static/media/Guitar-6.c40ecc01.jpg";